<template>
    <el-collapse
        v-model="collapseModel"
        class="base-collapse"
        v-bind="$attrs"
        v-on="listeners"
    >
        <slot />
    </el-collapse>
</template>

<script setup lang="ts">
import { Collapse as ElCollapse } from 'element-ui'
import { useVModel } from '@vueuse/core'
import { useListeners } from 'vue'

const props = defineProps<{
    value?: string | Array<string>
}>()
const emit = defineEmits([ 'input' ])

const listeners = useListeners()

const collapseModel = useVModel(props, 'value', emit, { eventName: 'input' })
</script>
